import _ from "lodash";
import localStorageUtils from "utils/localStorageUtils";

const LAST_WATCHED = "lw";
const SERIAL_OBJECTS_POSITION = "sop";

export const savePosition = (id, percent, position) => {
  try {
    const obj = JSON.parse(localStorageUtils.getItem(SERIAL_OBJECTS_POSITION));
    localStorageUtils.setItem(
      SERIAL_OBJECTS_POSITION,
      JSON.stringify({ ...obj, [id]: [percent, position] })
    );
  } catch (error) {
    console.error(error);
  }
};

export const clearPosition = (id) => {
  try {
    const obj = JSON.parse(localStorageUtils.getItem(SERIAL_OBJECTS_POSITION));
    if (obj) {
      const isDeleted = delete obj[id];
      if (isDeleted) {
        localStorageUtils.setItem(SERIAL_OBJECTS_POSITION, JSON.stringify(obj));
      }
    }
  } catch (error) {
    console.error(error);
  }
};

export const getPositions = () => {
  let result;
  try {
    result =
      JSON.parse(localStorageUtils.getItem(SERIAL_OBJECTS_POSITION)) || {};
  } catch (error) {
    console.error(error);
    result = {};
  }
  return result;
};

export const saveLastWatched = (id, videoId) => {
  try {
    const obj = JSON.parse(localStorageUtils.getItem(LAST_WATCHED));
    localStorageUtils.setItem(
      LAST_WATCHED,
      JSON.stringify({ ...obj, [id]: videoId })
    );
  } catch (error) {
    console.error(error);
  }
};

export const clearLastWatched = (id) => {
  try {
    const obj = JSON.parse(localStorageUtils.getItem(LAST_WATCHED));
    if (obj !== null) {
      delete obj[id];
      localStorageUtils.setItem(LAST_WATCHED, JSON.stringify({ ...obj }));
    }
  } catch (error) {
    console.error(error);
  }
};

export const getLastWatched = (id) => {
  let result;
  try {
    result = _.get(JSON.parse(localStorageUtils.getItem(LAST_WATCHED)), id);
  } catch (error) {
    console.error(error);
  }
  return result;
};
